import styled, { css } from "styled-components"
import { media } from "utils/Media"

const BlockTitle = styled.h3`
	font-family: ${props => props.theme.font.family.body};
	color: ${props => props.theme.colors.tertiary};
	line-height: 1.44;
	margin: 0;
	font-weight: 400;		
	text-transform: uppercase;
	padding-bottom: 1rem;
	font-size: 1.9rem; 

	@media ${media.xl} {
		font-size: ${props => props.theme.font.h2.size};
	}

	${props => props.template === "featured" && css`
	font-size: ${props => props.theme.font.size.xl};
	@media ${media.xl} {
		font-size: ${props => props.theme.font.size.xxl};
	}
	`}
	${props => props.color === 'black' && css`
		color: black;
		text-align: center;
		//font-style: italic;
		font-family: ${props => props.theme.font.family.body};
	`}

	${props => props.white && css`
		color: ${props => props.theme.colors.white};
	`}
	${props => props.primary && css`
		color: ${props => props.theme.colors.primary};
	`}
	${props => props.baseTitle && css`
		margin: 0 auto;
		text-align: center;
		font-family: ${props => props.theme.font.family.heading};
		text-transform: uppercase;
		//font-style: italic;
		font-size: ${props => props.theme.font.size.xl};
	`}
	${props => props.outline && css`
		-webkit-text-stroke: 2px white;
		color: ${props => props.theme.colors.white};
		color: transparent;
		letter-spacing: 1px;

		@media ${media.md} {
			-webkit-text-stroke: 3px white;
			letter-spacing: 0;
		}
	`}
	${props => props.newsTitle && css`
		margin: 0 auto;
		text-align: left;
		font-family: ${props => props.theme.font.family.heading};
		text-transform: uppercase;
		//font-style: italic;
		font-size: ${props => props.theme.font.size.xl};
	`}
	${props => props.$baseheading && css`
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.xl};
		text-transform: uppercase;
		//font-style: italic;
		text-align: center;
	`}
`

export default BlockTitle